import { render, staticRenderFns } from "./UserPointDetail.vue?vue&type=template&id=1bbb96b6&scoped=true&"
import script from "./UserPointDetail.vue?vue&type=script&lang=js&"
export * from "./UserPointDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserPointDetail.vue?vue&type=style&index=0&id=1bbb96b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbb96b6",
  null
  
)

export default component.exports